import { render, staticRenderFns } from "./CnasDeclarationAnnuellePage.vue?vue&type=template&id=45fea322&scoped=true&"
import script from "./CnasDeclarationAnnuellePage.vue?vue&type=script&lang=js&"
export * from "./CnasDeclarationAnnuellePage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fea322",
  null
  
)

export default component.exports